'use client';
import React from 'react';
import {THEWILETEASER_ID} from '../WaldorfRegistration';
import {Box} from '@mui/material';
import ReactHtmlParser from '@libs/reactHtmlParser';
export default function WaldorfButton(props: any) {
  const {t, className} = props;

  const handleRegister = () => {
    const element = document.getElementById(THEWILETEASER_ID);
    element?.scrollIntoView({behavior: 'smooth'});
  };

  return (
    <Box
      component='a'
      onClick={handleRegister}
      className={` ${className ?? ''}`}
      sx={{
        'flex': '0 0 auto',
        'display': 'flex',
        'flexDirection': 'column',
        'alignItems': 'center',
        'justifyContent': 'center',
        'cursor': 'pointer',
        'minWidth': {
          xs: '180px',
          sm: '180px',
          md: '200px',
          lg: '205px',
          xl: '205px',
        },
        'border': 'solid 1px #fff',
        'color': '#fff',
        'padding': {
          xs: '0 0.75rem',
          sm: '0 0.75rem',
          md: '0 0.1rem',
          lg: '0 1rem',
          xl: '0 1.5rem',
        },
        'textTransform': 'uppercase',
        'letterSpacing': '0.3rem',
        'minHeight': {
          xs: '36px',
          sm: '36px',
          md: '38px',
          lg: '40px',
          xl: '42px',
        },
        'fontSize': {
          xs: '12px',
          sm: '12px',
          md: '13px',
          lg: '14px',
          xl: '14px',
        },
        "[dir='rtl'] &": {
          letterSpacing: 'normal',
          minWidth: {
            xs: '130px',
            sm: '130px',
            md: '136px',
            lg: '140px',
            xl: '160px',
          },
        },
      }}>
      {ReactHtmlParser(t['waldorfRegisterButton'])}
    </Box>
  );
}
